import { useForm } from "react-hook-form";
import { useEffect } from "react";
import { useTitanApp } from "@/hooks/useTitanApp";
import { updateCurrentMemberProfile } from "@/dispatchers/memberDispatchers";
import fileToBase64 from "@/utils/fileToBase64";

interface User {
  FirstName: string;
  LastName: string;
  FullName: string;
  EmailAddress: string;
  gphcNumber: string;
  UserImage: string | null;
}

export const useGeneralProfileData = () => {
  const { appState, memberState } = useTitanApp();
  const { darkMode } = appState || {};
  const { currentMember, isCurrentProfileLoading, isMemberLoading } =
    memberState || {};
  const { firstName,lastName,fullName, emailAddress, userImage, gphcNumber } = currentMember || {};
  const isDarkMode = darkMode ?? false;
  const form = useForm<User>({
    mode: "onChange",
    defaultValues: {
      FirstName: firstName,
      LastName: lastName,
      EmailAddress: emailAddress,
      gphcNumber: gphcNumber,
      UserImage: userImage,
    },
  });
  const { register, handleSubmit, setValue, watch, reset, formState } = form;
  const { errors, isDirty, isValid } = formState;
  // Watch userImage field for changes
  const userImageWatch = watch("UserImage");

  useEffect(() => {
    if (currentMember) {
      reset({
        FullName: currentMember.fullName || "",
        EmailAddress: currentMember.emailAddress || "",
        gphcNumber: currentMember.gphcNumber || "",
        UserImage: currentMember.userImage || null,
      });
    }
  }, [currentMember, reset]);

  const onSubmit = async (data: User) => {
    const payload = {
      FirstName: data.FirstName || "",
      LastName: data.LastName || "",
      FullName: data.FullName,
      EmailAddress: data.EmailAddress,
      GPHCNumber: data.gphcNumber,
      UserImage: data.UserImage,
    };
    await updateCurrentMemberProfile(payload);
  };

  return {
    isDarkMode,
    isCurrentProfileLoading,
    isMemberLoading,
    register,
    handleSubmit,
    onSubmit,
    setValue,
    errors,
    isDirty,
    isValid,
    userImage,
    userImageWatch,
    fileToBase64,
  };
};
